import type { FaireProductEntity } from "../../entity_types/product";

export const p_n6vsmv2pt5: FaireProductEntity = {
  token: "p_n6vsmv2pt5",
  type: "product",
  name: "Women’s Short Sleeve Pullover Hoodie with Pocket_CWOHOS010",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/acd03888b57139f5ca8b3b9b1cfb3849f6dc89fd9eeca918b84bab0b8302dc59.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5aa4f71f1eb84fc4831aa09982584a03efeec66b06c9b10ee94e8e4dcb28903e.jpeg",
    "https://cdn.faire.com/fastly/552c475cc57e893cb7f8572a0508a51a4772776728c2304eb087a1bcdc9bccbc.jpeg",
    "https://cdn.faire.com/fastly/a0df86651be86c49ba5e315b23238794f2cce5dccd03ab151e679e6f8ac799b4.jpeg",
    "https://cdn.faire.com/fastly/285dc8eedbe8f9aad0aa767d00c5252da11dff9d6c19d60ee383ce26ea07357d.jpeg",
    "https://cdn.faire.com/fastly/f2c2eab9a49d960c01059b47c6b28779d06372f2044b4f1077141ba12d554815.jpeg",
    "https://cdn.faire.com/fastly/5a5ca6c51598fb61dba21d727121cc7eb94432cf6d6b32ab7ff301d300082fef.jpeg",
    "https://cdn.faire.com/fastly/6853ca4009fac78bf3aae64a3c7c5f254f10bb470b78854bc9eed764a2f04c0f.jpeg",
    "https://cdn.faire.com/fastly/20aac17eeb2d86e6f3b7d25572144027731407d073239f4a9b78484a38286ca3.jpeg",
    "https://cdn.faire.com/fastly/1775b55220737168e3e95c0380a112f2a8448e64bf407b91f2925b02379f03b8.jpeg",
    "https://cdn.faire.com/fastly/47db8b2285dd450f9a17bf159e3f8d35aad3b2e12254686925a278c62310e7ff.jpeg",
    "https://cdn.faire.com/fastly/7c0719a85c903d31e0b72d81710a6a9bc18a2ba78430837167243a5027f49ccb.jpeg",
    "https://cdn.faire.com/fastly/57d29a445a7673ef1d264a08944571e5aa049a2deebf754070249392acacc9f6.jpeg",
    "https://cdn.faire.com/fastly/f1cb814cedb915b47ea277bc6d86f263fe83df4a5290f8571794bf11591b9c9e.jpeg",
    "https://cdn.faire.com/fastly/c088e26053d82cdc22fece8e06e0bc2807264dded79bb6d85e29f5e22f7ab4e9.jpeg",
    "https://cdn.faire.com/fastly/fdcb170712fc099bd46eab59b4f57d734276881157a1bbeaa56925a68e2780fe.jpeg",
    "https://cdn.faire.com/fastly/b3149f21ed5cd6865d32ba53586be096c655374d7b2868af9e3a516185f4523a.jpeg",
    "https://cdn.faire.com/fastly/8f7d9e9951a31595b3ed055582a6d170b32eac5558d0cb471092487b77124f4a.jpeg",
    "https://cdn.faire.com/fastly/b7e6b693d56a1010aa433539519953fa9c6c8703ad33194c558031742f7fe10a.jpeg",
    "https://cdn.faire.com/fastly/6e6ee9776d98f2d5b662c37c3205261df5280c67fd343223e710c4187af7bf0d.png",
  ],
  priceDollars: 12.25,
  description:
    "60% Cotton, 40% Polyester\nSIZE  S / M / L / XL\nMADE IN CHINA\n\n* MODEL IS 5'7\" AND IS WEARING A SIZE SMALL\n\nKNIT HODDED, SWEATSHIRT, SWEATPANTS, KNIT TOP, LOOSE TEE, WOMEN BLAZER, PLAID SHACKET, OVERSIZED SWEATER, V NECK SWEATER, FLANNEL JACKET, PLAID SHACKET, CABLE KNIT SWEATER, CROCHET CARDIGAN, WESTERN, BOHEMIAN, PLUS SIZE CLOTHING,BACK TO SCHOOL",
  tags: [],
  msrpDollars: 24.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:22.795Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
